// extracted by mini-css-extract-plugin
export var chip = "_3y-0";
export var filterDropdown = "_3y-5";
export var filterItem = "_3y-6";
export var icon = "_3y-1";
export var removeButton = "_3y-3";
export var removeIcon = "_3y-4";
export var separator = "_3y-2";